import { Component, Directive, Input, Output, HostListener, HostBinding, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
var SuiCheckbox = (function () {
    function SuiCheckbox() {
        this._classes = true;
        this.isChecked = false;
        this.checkChange = new EventEmitter(false);
        this.isDisabled = false;
        this.isReadonly = false;
    }
    Object.defineProperty(SuiCheckbox.prototype, "checkedAttribute", {
        /**
         * @return {?}
         */
        get: function () {
            return this.isChecked ? "" : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiCheckbox.prototype, "isDisabledAttribute", {
        /**
         * @return {?}
         */
        get: function () {
            return this.isDisabled ? "disabled" : null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SuiCheckbox.prototype.onClick = function () {
        if (!this.isDisabled && !this.isReadonly) {
            this.toggle();
        }
    };
    /**
     * @return {?}
     */
    SuiCheckbox.prototype.toggle = function () {
        this.isChecked = !this.isChecked;
        this.checkChange.emit(this.isChecked);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    SuiCheckbox.prototype.writeValue = function (value) {
        var _this = this;
        setTimeout(function () {
            _this.isChecked = value;
        });
    };
    return SuiCheckbox;
}());
export { SuiCheckbox };
SuiCheckbox.decorators = [
    { type: Component, args: [{
                selector: 'sui-checkbox',
                exportAs: 'suiCheckbox',
                template: "\n<input class=\"hidden\" type=\"checkbox\" [attr.name]=\"name\" [attr.checked]=\"checkedAttribute\" [attr.disabled]=\"isDisabledAttribute\" [(ngModel)]=\"isChecked\">\n<label>\n    <ng-content></ng-content>\n</label>\n"
            },] },
];
/**
 * @nocollapse
 */
SuiCheckbox.ctorParameters = function () { return []; };
SuiCheckbox.propDecorators = {
    '_classes': [{ type: HostBinding, args: ['class.ui',] }, { type: HostBinding, args: ['class.checkbox',] },],
    'name': [{ type: Input },],
    'isChecked': [{ type: HostBinding, args: ['class.checked',] },],
    'checkChange': [{ type: Output },],
    'isDisabled': [{ type: Input },],
    'isReadonly': [{ type: HostBinding, args: ['class.read-only',] }, { type: Input },],
    'onClick': [{ type: HostListener, args: ['click',] },],
};
function SuiCheckbox_tsickle_Closure_declarations() {
    /** @type {?} */
    SuiCheckbox.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    SuiCheckbox.ctorParameters;
    /** @type {?} */
    SuiCheckbox.propDecorators;
    /** @type {?} */
    SuiCheckbox.prototype._classes;
    /** @type {?} */
    SuiCheckbox.prototype.name;
    /** @type {?} */
    SuiCheckbox.prototype.isChecked;
    /** @type {?} */
    SuiCheckbox.prototype.checkChange;
    /** @type {?} */
    SuiCheckbox.prototype.isDisabled;
    /** @type {?} */
    SuiCheckbox.prototype.isReadonly;
}
export var /** @type {?} */ CUSTOM_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return SuiCheckboxValueAccessor; }),
    multi: true
};
var SuiCheckboxValueAccessor = (function () {
    /**
     * @param {?} host
     */
    function SuiCheckboxValueAccessor(host) {
        this.host = host;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    SuiCheckboxValueAccessor.prototype.writeValue = function (value) {
        this.host.writeValue(!!value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SuiCheckboxValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    SuiCheckboxValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    return SuiCheckboxValueAccessor;
}());
export { SuiCheckboxValueAccessor };
SuiCheckboxValueAccessor.decorators = [
    { type: Directive, args: [{
                selector: 'sui-checkbox',
                host: { '(checkChange)': 'onChange($event)' },
                providers: [CUSTOM_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
SuiCheckboxValueAccessor.ctorParameters = function () { return [
    { type: SuiCheckbox, },
]; };
function SuiCheckboxValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    SuiCheckboxValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    SuiCheckboxValueAccessor.ctorParameters;
    /** @type {?} */
    SuiCheckboxValueAccessor.prototype.onChange;
    /** @type {?} */
    SuiCheckboxValueAccessor.prototype.onTouched;
    /** @type {?} */
    SuiCheckboxValueAccessor.prototype.host;
}
export var /** @type {?} */ SUI_CHECKBOX_DIRECTIVES = [SuiCheckbox, SuiCheckboxValueAccessor];
//# sourceMappingURL=checkbox.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-semantic-ui/components/checkbox/checkbox.js
// module id = ./node_modules/ng2-semantic-ui/components/checkbox/checkbox.js
// module chunks = vendor